import { render, staticRenderFns } from "./footerCMS.vue?vue&type=template&id=0f9f464f&"
import script from "./footerCMS.vue?vue&type=script&lang=js&"
export * from "./footerCMS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports